import { useState } from "react";
import { toast } from "sonner";
import { Wrench } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const METODOS = [["efectivo", "Efectivo"], ["tarjeta", "Tarjeta"], ["tarjeta_debito", "T. Débito"], ["tarjeta_credito", "T. Crédito"], ["transferencia", "Transferencia"]];

/** Corrección ERP (gran_admin/coordinador) de método de pago y/o monto de una venta o gasto mal capturado. Deja bitácora y re-sincroniza. */
export default function CorregirDialog({ tipo, item, onClose, onSaved }) {
  const esVenta = tipo === "venta";
  const metodoActual = esVenta ? (item?.pagos?.[0]?.metodo || "") : (item?.metodo_pago || "");
  const montoActual = esVenta ? item?.total : item?.monto;
  const [metodo, setMetodo] = useState(metodoActual);
  const [monto, setMonto] = useState(montoActual != null ? String(montoActual) : "");
  const [motivo, setMotivo] = useState("");
  const [busy, setBusy] = useState(false);

  async function guardar() {
    if (!motivo.trim()) return toast.error("Indica el motivo de la corrección");
    setBusy(true);
    try {
      const payload = { motivo: motivo.trim() };
      if (metodo && metodo !== metodoActual) payload.metodo_pago = metodo;
      if (monto !== "" && parseFloat(monto) !== Number(montoActual)) payload.monto = parseFloat(monto);
      const { data } = await api.put(`/${esVenta ? "ventas" : "gastos"}/${item.id}/corregir`, payload);
      toast.success(`${esVenta ? "Venta" : "Gasto"} ${item.folio} corregido · el corte se recalcula solo`);
      onSaved?.(data); onClose();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  }

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-md rounded-2xl" data-testid="corregir-dialog">
        <DialogHeader><div className="eyebrow flex items-center gap-1"><Wrench className="w-3.5 h-3.5 text-brand-amber" /> Corregir {esVenta ? "venta" : "gasto"}</div><DialogTitle className="font-display text-lg font-bold">{item?.folio}</DialogTitle></DialogHeader>
        <p className="text-xs text-brand-muted">Corrige lo capturado por error (p. ej. era tarjeta y quedó en efectivo). Queda registrado en bitácora y se re-sincroniza con RubiNOVA.</p>
        <label className="eyebrow mt-1">Método de pago</label>
        <select data-testid="corregir-metodo" value={metodo} onChange={(e) => setMetodo(e.target.value)} className="field h-11">{METODOS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
        <label className="eyebrow">Monto</label>
        <input data-testid="corregir-monto" type="number" min="0.01" step="0.01" value={monto} onChange={(e) => setMonto(e.target.value)} className="field h-11 font-mono" />
        <label className="eyebrow">Motivo de la corrección</label>
        <input data-testid="corregir-motivo" autoFocus value={motivo} onChange={(e) => setMotivo(e.target.value)} placeholder="Ej. Se capturó efectivo pero fue tarjeta" className="field h-11" />
        <button data-testid="corregir-guardar" disabled={busy || !motivo.trim()} onClick={guardar} className="btn-amber w-full h-11 disabled:opacity-40">{busy ? "Guardando…" : "Guardar corrección"}</button>
      </DialogContent>
    </Dialog>
  );
}
